import {
  getPage,
  getDetail,
  getClientPage,
} from '@/api/timeoutparkinganalysisresultserv'

export default {
  state: {
    state_TimeoutParkingAnalysisResult_GetPageResult: null,
    state_TimeoutParkingAnalysisResult_GetDetailResult: null,
    state_TimeoutParkingAnalysisResult_GetClientPageResult: null,
  },
  mutations: {
    SET_TIMEOUTPARKINGANALYSISRESULT_GETPAGE_RESULT: (state, rst) => {
      state.state_TimeoutParkingAnalysisResult_GetPageResult = rst;
    },
    SET_TIMEOUTPARKINGANALYSISRESULT_GETDETAIL_RESULT: (state, rst) => {
      state.state_TimeoutParkingAnalysisResult_GetDetailResult = rst;
    },
    SET_TIMEOUTPARKINGANALYSISRESULT_GETCLIENTPAGE_RESULT: (state, rst) => {
      state.state_TimeoutParkingAnalysisResult_GetClientPageResult = rst;
    },
  },
  actions: {
    TimeoutParkingAnalysisResultServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_TIMEOUTPARKINGANALYSISRESULT_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_TIMEOUTPARKINGANALYSISRESULT_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    TimeoutParkingAnalysisResultServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_TIMEOUTPARKINGANALYSISRESULT_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_TIMEOUTPARKINGANALYSISRESULT_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    TimeoutParkingAnalysisResultServ_GetClientPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getClientPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_TIMEOUTPARKINGANALYSISRESULT_GETCLIENTPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_TIMEOUTPARKINGANALYSISRESULT_GETCLIENTPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_TimeoutParkingAnalysisResult_GetPageResult: state => {
      return state.state_TimeoutParkingAnalysisResult_GetPageResult;
    },
    get_TimeoutParkingAnalysisResult_GetDetailResult: state => {
      return state.state_TimeoutParkingAnalysisResult_GetDetailResult;
    },
    get_TimeoutParkingAnalysisResult_GetClientPageResult: state => {
      return state.state_TimeoutParkingAnalysisResult_GetClientPageResult;
    },
  }
}